import type { PlanLogoName } from '@shared/shared-constants/plan-logos';

import type { CommunityMember } from './member';
import type { CommunityGate, CommunityLockReason } from './space';

export interface CommunityNavSubtitle {
  type: 'link' | 'tagline';
  text: string;
  url: string | null;
}

export interface Community {
  id: string;
  publication_id?: string;
  name: string;
  description?: string | null;
  app_adoption_tracking_enabled?: boolean;
  pwa_enabled: boolean;
  dms_enabled: boolean;
  directory_enabled: boolean;
  directory_name?: string | null;
  nav_subtitle?: CommunityNavSubtitle | null;
  background_color: string;
  text_on_background_color: string;
  primary_color: string;
  text_on_primary_color: string;
  gated: boolean;
  premium_tier_ids: string[];
  sync_comments_enabled: boolean;
  member_blocking_enabled: boolean;
  message_reactions_enabled?: boolean;
  video_enabled?: boolean;
  first_premium_offer_id: string | null;
  community_accessible: boolean;
  lock_reason: CommunityLockReason | null;
  gate: CommunityGate | null;
  mobile_app_callout_enabled: boolean;
  feed_first_enabled: boolean;
  post_history_days?: number | null;
  // Only admins and managers get it, when a plan upgrade shows members more post history.
  post_history_upsell?: CommunityPostHistoryUpsell;
  member_notification_emails_enabled: boolean;
  mentions_enabled: boolean;
  navigation_v2_enabled: boolean;
  luma_embed_url?: string | null;
  logo_url?: string | null;
  member_count?: number;
  preview_members?: CommunityMember[];
}

export interface CommunityPostHistoryUpsellPlan {
  id: PlanLogoName;
  name: string;
  // Null means the plan shows members the whole history.
  days: number | null;
}

export interface CommunityPostHistoryUpsell {
  upgrade_url: string;
  current_plan_name: string;
  plans: CommunityPostHistoryUpsellPlan[];
}

export enum CommunitySendableType {
  CommunityPost = 'community_post',
  CommunitySpace = 'community_space',
}
